module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Spacing_After"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-family": "BigNoodleTitling",
      "font-size": "3.33em"
    }
  }, [_vm._v("Part One")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-family": "BigNoodleTitling",
      "font-size": "1.67em"
    }
  }, [_vm._v("Conversations With The Dead")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“The real problem with talking to the dead isn’t getting them to speak. It’s getting them to shut up again once they start.”"), _c('br')]), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("- Jadim Cartarssi, Armchair Necro-psychologist")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e75ce9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0006.vue
// module id = 78
// module chunks = 0